import React, { useState } from 'react';
import { Package, Layers } from 'lucide-react';
import { ComponentLibrary } from '@components/Sidebar/ComponentLibrary';
import { GroupsLibrary } from '@components/Sidebar/GroupsLibrary';

type Tab = 'components' | 'groups';

export const LeftSidebar: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('components');

  return (
    <div className="flex h-full w-full flex-col border-r border-gray-200 bg-gray-50 shadow-2xl dark:border-slate-700 dark:bg-slate-900">
      {/* Tab Switcher */}
      <div className="flex border-b border-gray-200 dark:border-gray-700">
        <button
          onClick={() => setActiveTab('components')}
          className={`flex flex-1 items-center justify-center gap-2 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'components'
              ? 'border-b-2 border-blue-500 bg-white text-blue-600 dark:bg-gray-800 dark:text-blue-400'
              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'
          }`}
        >
          <Package className="h-4 w-4" />
          <span className="hidden sm:inline">Components</span>
        </button>
        <button
          onClick={() => setActiveTab('groups')}
          className={`flex flex-1 items-center justify-center gap-2 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'groups'
              ? 'border-b-2 border-blue-500 bg-white text-blue-600 dark:bg-gray-800 dark:text-blue-400'
              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'
          }`}
        >
          <Layers className="h-4 w-4" />
          <span className="hidden sm:inline">Groups</span>
        </button>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'components' ? <ComponentLibrary /> : <GroupsLibrary />}
      </div>
    </div>
  );
};
